import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ActionButton from '../../action-button';
import ButtonSkeleton from '../../skeletons/button-skeleton';
import { ACTIONS_TYPES, captionsType } from '../types';

const Actions = ({
  captions,
  onPreviewClick,
  onStartEditingClick,
  type = ACTIONS_TYPES.content,
  isLoading = false,
}) => {
  const classes = classNames(
    'ws-ui-template-preview-container__actions',
    `ws-ui-template-preview-container__actions--${type}`
  );

  return (
    <div className={classes}>
      {isLoading ? (
        <React.Fragment>
          <div>
            <ButtonSkeleton size="large" />
          </div>
          <div>
            <ButtonSkeleton size="large" />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ActionButton
            format={type === ACTIONS_TYPES.floating ? 'solid-white' : 'outline'}
            label={captions.preview}
            onClick={onPreviewClick}
          />
          <ActionButton
            appearance="accent"
            format="solid"
            label={captions.startEditing}
            onClick={onStartEditingClick}
          />
        </React.Fragment>
      )}
    </div>
  );
};

Actions.propTypes = {
  onPreviewClick: PropTypes.func.isRequired,
  onStartEditingClick: PropTypes.func.isRequired,
  captions: PropTypes.shape(captionsType).isRequired,
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(ACTIONS_TYPES)),
};

export default Actions;
